import { jwtDecode } from "jwt-decode";

const roleKey = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
const userIdKey = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier";

export const tryGetRolesFromJwt = (token: string): string[] => {
	if (!token) {
		return [];
	}

	try {
		const data = jwtDecode(token) as any;

		return !!data ? data[roleKey] || [] : [];
	} catch {
		return [];
	}
};

export const isTokenExpired = (
	token: string | null,
	secondsBefore: number = 20
): boolean => {
	if (!token) {
		return true;
	}

	try {
		const exp = (jwtDecode(token) as any)?.exp;

		return !!exp && exp - Math.floor(new Date().getTime() / 1000) < secondsBefore;
	} catch {
		return true;
	}
};

export const tryGetUserIdFromJwt = (token: string): string => {
	if (!token) {
		return '';
	}

	try {
		const data = jwtDecode(token) as any;

		return !!data ? data[userIdKey] || '' : '';
	} catch {
		return '';
	}
};